import { getCookie, removeCookie, setCookie } from "../cookies";

const PROVINCE_COOKIE = {
  PROVINCE_NAME: "province",
  PROVINCE_ACCEPTED: "provinceAccepted",
} as const;

export const setProvinceAcceptedCookie = (isProvinceAccepted: boolean = true) => {
  setCookie(PROVINCE_COOKIE.PROVINCE_ACCEPTED, isProvinceAccepted ? "true" : "false", "/");
};

export const setProvinceCookies = (provinceName?: string) => {
  if (!provinceName) return;

  setCookie(PROVINCE_COOKIE.PROVINCE_NAME, provinceName, "/");
  setProvinceAcceptedCookie(false);
};

export const clearProvinceCookies = () => {
  removeCookie(PROVINCE_COOKIE.PROVINCE_NAME);
  removeCookie(PROVINCE_COOKIE.PROVINCE_ACCEPTED);
};

export const getProvinceCookies = () => {
  const province = getCookie(PROVINCE_COOKIE.PROVINCE_NAME);
  const provinceAccepted = getCookie(PROVINCE_COOKIE.PROVINCE_ACCEPTED) === "true";

  return { province, provinceAccepted };
};
